import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9eca5b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "col-md-12" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "View Invoice")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("button", { class: "btn btn-secondary" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "k-icon k-i-file-excel" }),
    /*#__PURE__*/_createTextVNode(" Export ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.isLoading && _ctx.invoices?.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Grid, {
              "data-items": _ctx.invoices,
              columns: _ctx.columns
            }, {
              invoiceNumber: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.invoiceNumber), 1)
                ])
              ]),
              dateFrom: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.dateFrom), 1)
                ])
              ]),
              dateTo: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.dateTo), 1)
                ])
              ]),
              netTotal: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.netTotal), 1)
                ])
              ]),
              vat: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.vat), 1)
                ])
              ]),
              total: _withCtx(({props}) => [
                _createElementVNode("td", null, [
                  _createElementVNode("span", null, _toDisplayString(props.dataItem.total), 1)
                ])
              ]),
              invoice: _withCtx(() => [
                _hoisted_6
              ]),
              transactions: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["data-items", "columns"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}